"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DevourIQInjectManualOrderBodyToJSON = exports.DevourIQInjectManualOrderBodyFromJSONTyped = exports.DevourIQInjectManualOrderBodyFromJSON = void 0;
function DevourIQInjectManualOrderBodyFromJSON(json) {
    return DevourIQInjectManualOrderBodyFromJSONTyped(json, false);
}
exports.DevourIQInjectManualOrderBodyFromJSON = DevourIQInjectManualOrderBodyFromJSON;
function DevourIQInjectManualOrderBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'uberEatsOrderURL': json['uberEatsOrderURL'],
        'uberEatsAccountID': json['uberEatsAccountID'],
    };
}
exports.DevourIQInjectManualOrderBodyFromJSONTyped = DevourIQInjectManualOrderBodyFromJSONTyped;
function DevourIQInjectManualOrderBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'uberEatsOrderURL': value.uberEatsOrderURL,
        'uberEatsAccountID': value.uberEatsAccountID,
    };
}
exports.DevourIQInjectManualOrderBodyToJSON = DevourIQInjectManualOrderBodyToJSON;
